export const REPLICA_LIST_EXTENDED_PROPERTY_TAG = "0x6698";
